/** Grade `seen === 2` = athlete marked individual eval as read (player-app + indicator-max). */
export const EVAL_SEEN_REVIEWED = 2;

export const isEvalReviewed = (row) => Number(row?.seen) === EVAL_SEEN_REVIEWED;

export const formatGroupReadLabel = ({ read, total, unseen, hasFeedback }) => {
  if (!hasFeedback) return "No Feedback";
  if (!total) return null;
  if (read === 0 && unseen > 0) return `${unseen} Unseen`;
  return `${read}/${total} Read`;
};

const namesFromMembers = (list) =>
  (list || []).map((m) => m?.name).filter(Boolean);

/** Normalize `GET …/thread-reads/summary` payload (axios wrap: data.data). */
export const parseThreadReadSummary = (data) => {
  const payload = data?.data?.data ?? data?.data ?? data ?? {};
  const read = Number(payload.read) || 0;
  const total = Number(payload.total) || 0;
  const unseen = Number(payload.unseen) || Math.max(0, total - read);
  return {
    read,
    total,
    unseen,
    seen: namesFromMembers(payload.seen),
    notSeen: namesFromMembers(payload.not_seen),
  };
};
